import { router, usePage } from '@inertiajs/react'
import { Dropdown } from '@/shared/components/Dropdown'
import { DropdownAction } from '@/shared/components/DropdownAction'
import { Icon } from '@/shared/components/Icon'
import { Button } from '@/shared/components/Button'
import { useLocale, useT, LOCALES, type Locale } from './index'

// Surface-agnostic language switcher. PUTs the chosen locale to the shared
// /locale endpoint; Rails persists it (session/cookie/user preference) and
// redirects back so the reloaded page re-shares the new `locale` prop.
export function LocaleSwitcher({ fullLabel = false }: { fullLabel?: boolean }) {
  const t = useT()
  const current = useLocale()
  const { available_locales } = usePage().props as { available_locales?: string[] }
  const locales = (available_locales?.filter((l): l is Locale =>
    LOCALES.includes(l as Locale),
  )) ?? LOCALES

  return (
    <Dropdown
      placement="bottom-end"
      trigger={
        fullLabel ? (
          <Button icon="globe" aria-label={`${t('locale_switcher.label')}: ${t(`locale_name.${current}`)}`}>
            {t(`locale_name.${current}`)}
          </Button>
        ) : (
          <button type="button" className="topbar__btn locale-switcher__trigger" aria-label={t('locale_switcher.label')}>
            <Icon name="globe" size={18} aria-hidden="true" />
            <span aria-hidden="true">{current.toUpperCase()}</span>
          </button>
        )
      }
    >
      {locales.map((code) => (
        <DropdownAction
          key={code}
          type="button"
          role="menuitem"
          className={code === current ? 'dd__item dd__item--active' : 'dd__item'}
          lang={code}
          aria-current={code === current ? 'true' : undefined}
          onClick={() =>
            router.put('/locale', { locale: code }, { preserveScroll: true })
          }
        >
          {t(`locale_name.${code}`)}
        </DropdownAction>
      ))}
    </Dropdown>
  )
}
